export default __webpack_public_path__ + "static/media/product3.e397c622.jpg";